module.exports = __webpack_public_path__ + "img/payment-old.ed761289.jpg";